const calcPrice = (
    departure_date,
    return_date,
    departure_hub_code,
    return_hub_code,
    client_address,
    second_address,
    couponcode,
    departure_stopovers,
    return_stopovers,
    departure_share_type,
    return_share_type,
    departure_place_id,
    return_place_id,
    shareTierInput = {},
) =>{
    const myHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "X-CSRF-TOKEN" : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }

    const options = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
            departure_date, 
            return_date, 
            departure_hub_code, 
            return_hub_code, 
            client_address, 
            second_address, 
            couponcode, 
            departure_stopovers, 
            return_stopovers, 
            departure_share_type, 
            return_share_type,
            departure_place_id,
            return_place_id,
            // The server decides the share discount tier from the flights, the pax and the load
            // and returns the price each leg is charged (COMPR-501).
            ...shareTierInput,
        }),
        redirect: 'follow'
    };

    return fetch(`/api/website/calcprice`, options);
}

const createOrder = async (data) =>{
    const myHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "X-CSRF-TOKEN" : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
    
    const options = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
            wantsDepartureTransfer: data.wantsDepartureTransfer,
            wantsReturnTransfer: data.wantsReturnTransfer,
            po: data.po,
            reseller_name: data.reseller_name,
            departure_airport: data.departureAirport,
            departure_date: (data.wantsDepartureTransfer ? data.departureDate + ' ' + data.departureTime : null),
            departure_flight: data.departureFlight,
            checkin: parseFloat(data.checkin) * 60,
            return_airport: data.returnAirport,
            return_date: (data.wantsReturnTransfer ? data.returnDate + ' ' + data.returnTime : null),
            return_flight: data.returnFlight,
            destination_airport: data.destination,
            firstname: data.firstname,
            name: data.name,
            user_language: data.language,
            email: data.email,
            phone: data.phone,
            departure_address: data.full_address,
            departure_place_id: data.departurePlaceId,
            departure_share_type: data.departureShared,
            wants_same_facturation_address: data.wantsSameFacturationAddress,
            facturation_company_name: data.facturation_company_name,
            facturation_vat: data.facturation_vat,
            facturation_street: data.facturation_street,
            facturation_street_nr: data.facturation_street_nr + (data.facturation_street_box? ' ' + data.facturation_street_box : ''),
            facturation_city: data.facturation_city,
            facturation_zip: data.facturation_zip,
            facturation_country: data.facturation_country,
            suitcases: data.suitcases,
            wantsads: data.wantsads,
            amount_adults: parseInt(data.adults),
            amount_children: parseInt(data.children121),
            amount_infants: parseInt(data.infants),
            cargo_names: [
                'bikecases',
                'babycarriages',
                'wheelchairs',
                'skies',
                'rollators',
                'golfbags',
            ],
            cargo_amounts: [
                data.bikecases,
                data.babycarriages,
                data.wheelchairs,
                data.skies,
                data.rollators,
                data.golfbags,
            ],
            comments: data.comments,
            couponcode: data.couponcode,
            return_dropoff_address: data.dropoff_full_address,
            return_dropoff_place_id: data.returnPlaceId,
            return_share_type: data.returnShared,
            departure_stopovers: data.departure_stopovers,
            return_stopovers: data.return_stopovers,
            facturation_target: data.facturation_target,
            customerBrand: data.customerBrand,
            referred_by: data.referred_by,
        }),
        redirect: 'follow'
    };

    let resp = await fetch(`/api/website/orderrequest/store`, options);
    return resp;
}

const checkPayment = async (uuid) =>{
    const myHeaders = {
        "X-CSRF-TOKEN" : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }

    const options = {
        method: 'GET',
        headers: myHeaders
    };

    let resp = await fetch(`/api/website/payment/${uuid}`, options);
    return resp;
}

const retryPayment = async (oldPaymentUuid, customerBrandSlug = null) =>{
    const myHeaders = {
        "X-CSRF-TOKEN" : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }

    const options = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    const slug = customerBrandSlug ?? 'public';
    let resp = await fetch(`/api/website/payment/${slug}/${oldPaymentUuid}/retry`, options);
    return resp;
}

function getCurrentDate(){

    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    
    return `${year}-${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}`
}

function getNextDate(oldDate, daystoadd=1){
    let newDate = new Date(oldDate)
    newDate.setDate(newDate.getDate() + daystoadd);
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    
    return `${year}-${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}`
}

const capitalizeFirstLetter = (string) => {
    if(!!string){
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return '';
}

const checkPlaceId = async (place_id) => {
    const myHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "X-CSRF-TOKEN" : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }


    const options = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
            place_id,
        }),
        redirect: 'follow'
    };

    let resp = await fetch(`/api/website/checkAddress`, options);

    return await resp.json();
}

export {
    calcPrice,
    checkPayment,
    createOrder,
    getCurrentDate,
    getNextDate,
    retryPayment,
    capitalizeFirstLetter,
    checkPlaceId
}